<template>
    <div>
        <college-banner></college-banner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1>Edit Profile</h1>
                                        </div>
                                    </div>
                                </div>
                                <div class="college-profile-form">
                                    <form action="" @submit.prevent="update">
                                        <div class="row">
<!--                                            <div class="col-md-12">-->
<!--                                                <div class="epp">-->
<!--                                                    <div class="edit-profile-pic">-->
<!--                                                        <img v-bind:src="image" v-if="image">-->
<!--                                                        <img src="/images/user_avatar.png" v-else>-->
<!--                                                        <label for="cp-edit"><i class="fas fa-pencil-alt"></i></label>-->
<!--                                                    </div>-->
<!--                                                    <div class="pic-details">-->
<!--                                                        <input type="file" id="cp-edit" class="file"-->
<!--                                                               @change="onPhotoUploaded">-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->
                                            <div class="col-md-12 col-sm-12">
                                                <div class="form-group">
                                                    <label class="ep-input-label" for="college_name">College
                                                        Name</label>
                                                    <input type="text" class="form-control dash-input" id="college_name"
                                                           placeholder="College Name"
                                                           name="college_name" v-model="college_name" disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label for="job-des" class="ep-input-label">About College</label>
                                                    <textarea id="job-des" class="form-control dash-input"
                                                              v-model="college_description"></textarea>
                                                    <div id="job-er" class="form-text text-muted"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="ep-input-label" for="college_web">College
                                                        Website</label>
                                                    <input type="text" class="form-control dash-input" id="college_web"
                                                           placeholder="Website"
                                                           name="college_web" v-model="college_website">
                                                    <div id="college-er" v-html="website_error"
                                                         class="form-text text-muted"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="ep-input-label" for="college_affi">Affiliated
                                                        To</label>
                                                    <input type="text" class="form-control dash-input" id="college_affi"
                                                           placeholder="University Name"
                                                           name="college_affi" v-model="college_affiliated_to">
                                                    <div id="university-er" v-html="affiliated_to_error"
                                                         class="form-text text-muted"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="ep-input-label" for="college_loc">Location</label>
                                                    <input type="text" class="form-control dash-input" id="college_loc"
                                                           placeholder="Location"
                                                           name="college_loc" v-model="college_city">
                                                    <div id="location-er" v-html="city_error"
                                                         class="form-text text-muted"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="ep-input-label" for="college_number">Email</label>
                                                    <input type="text" class="form-control dash-input" id="email"
                                                           placeholder="Email" name="college_email"
                                                           v-model="college_email" disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="ep-input-label" for="college_number">Phone
                                                        Number</label>
                                                    <input type="text" class="form-control dash-input"
                                                           id="college_number" placeholder="Phone Number"
                                                           name="college_number" v-model="college_phone" disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <StreamModal></StreamModal>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                      <div class="edit-form-heading mt30">Stream</div>
                                                    </div>
                                                </div>
                                              <div class="all-courses">
                                                <div class="row">
                                                  <div class="col-md-3">
                                                    <div class="course-box">
                                                      <div class="course-details">
                                                        <div class="course-name">
                                                          <button type="button"  @click="streamModal(true)">
                                                            <i class="fas fa-plus"></i>
                                                          </button>
                                                        </div>
                                                        <div class="course-duration">Add New</div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="col-md-3" v-for="s in streams">
                                                    <div class="course-box">
                                                      <div class="course-details">
                                                        <div class="course-name">{{s.stream}}</div>
<!--                                                        <div class="course-duration">3 Courses</div>-->
                                                      </div>
<!--                                                      <div class="course-edit">-->
<!--                                                        <button type="button">-->
<!--                                                          <i class="fas fa-pen"></i></button>-->
<!--                                                      </div>-->
                                                      <div class="course-remove">
                                                        <button type="button" @click="removeStream($event)" v-bind:data-key="s.assigned_college_enc_id">
                                                          <i class="fas fa-times"></i>
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-12">
                                                <courseModal ref="cModal"></courseModal>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="edit-form-heading">Courses</div>
                                                    </div>
                                                </div>
                                                <div class="all-courses">
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <div class="course-box">
                                                                <div class="course-details">
                                                                    <div class="course-name">
                                                                        <button type="button"
                                                                                @click="courseModal(true)"><i
                                                                                class="fas fa-plus"></i></button>
                                                                    </div>
                                                                    <div class="course-duration">Add New</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3" v-for="cl in coursesList">
                                                            <div class="course-box">
                                                                <div class="course-details">
                                                                    <div class="course-name">{{cl.course_name}}</div>
                                                                    <div class="course-duration">{{cl.course_duration}}
                                                                        {{cl.type}}
                                                                    </div>
                                                                </div>
                                                                <div class="course-edit">
                                                                    <button type="button"
                                                                            @click="courseModal(false, $event)"
                                                                            v-bind:data-key="cl.assigned_college_enc_id">
                                                                        <i class="fas fa-pen"></i></button>
                                                                </div>
                                                                <div class="course-remove">
                                                                  <button type="button" @click="removeCourse($event)" v-bind:data-key="cl.assigned_college_enc_id">
                                                                    <i class="fas fa-times"></i>
                                                                  </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="align-center">
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <button type="" class="add-course">Update</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 margin-top-20">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1>Change Account Setting</h1>
                                        </div>
                                    </div>
                                </div>
                                <div class="college-profile-form">
                                    <form id="changePassForm" @submit.prevent="changePassword()">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="ep-input-label" for="old-password">Old
                                                        Password</label>
                                                    <input type="password" class="form-control dash-input field-req"
                                                           id="old-password" placeholder="Old Password"
                                                           name="old_password">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="ep-input-label" for="new-password">New
                                                        Password</label>
                                                    <input type="password" class="form-control dash-input field-req"
                                                           id="new-password" placeholder="New Password"
                                                           name="new_password">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="ep-input-label" for="confirm-password">Confirm
                                                        Password</label>
                                                    <input type="password" class="form-control dash-input field-req"
                                                           id="confirm-password" placeholder="Confirm New Password"
                                                           name="repeat_new_password">
                                                </div>
                                            </div>
                                            <div class="col-md-12 text-center">
                                                <div class="form-group">
                                                    <button type="submit" class="add-course">Change Password</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import courseModal from './../../components/courseModal.vue'
    import StreamModal from './../../components/StreamModal.vue'
    import collegeBanner from './../../components/collegeBanner.vue'
    import CollegeSideNavLayout from './../../components/CollegeSideNavLayout.vue'
    import axios from 'axios';
    import toastr from '../../../public/js/toastr.js';
    import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

    export default {
        components: {
            CollegeSideNavLayout,
            courseModal,
            collegeBanner,
            StreamModal
        },
        data() {
            return {
                image: '',
                college_name: '',
                valid: false,
                college_description: '',
                college_enc_id: '',
                college_phone: '',
                college_email: '',
                college_website: '',
                college_city: '',
                college_affiliated_to: '',
                city_error: '',
                coursesList: '',
                website_error: '',
                affiliated_to_error: '',
                streams: ''
            }
        },
        mounted() {
            var t = this;
            var url = t.$store.getters.getDomain;
            // //request to get profile image
            // axios.post(`${url}api/v2/college-profile/get-image`, '', {headers: headers}).then(function (response) {
            //     t.image = response['data'];
            // });

            //request to get details
            axios.post(`${url}api/v2/college-profile/fetch-details`, '', {headers: requestHeaders()}).then(function (response) {
                document.getElementById("h-page-load").classList.add("hides");
                var detail = response['data']['response']['detail'];
                t.college_name = t.htmlDecoder(detail['name']);
                t.college_website = detail['website'];
                t.college_description = detail['description'];
                t.college_phone = detail['phone'];
                t.college_email = detail['email'];
                t.college_enc_id = detail['organization_enc_id'];
                t.coursesList = response['data']['response']['courses'];
                t.$store.dispatch("setCourses", t.coursesList);
                t.image = detail['logo'];
                t.college_city = detail['city'];
                t.college_affiliated_to = detail['affiliated_to'];
                t.streams = response['data']['response']['streams'];
            });
        },
        computed: {
            changeImage() {
                return this.$store.getters.getImage;
            },
            changeCourse() {
                return this.$store.getters.getCourses;
            }
        },
        watch: {
            changeImage(value) {
                var t = this;
                t.image = value;
            },
            changeCourse(value) {
                var t = this;
                t.coursesList = value;
            },
        },
        methods: {
            // onPhotoUploaded(event) {
            //     this.loaderShow();
            //     var t = this;
            //     var url = this.$store.getters.getDomain;
            //     this.uploadedPhoto = event.target.files[0];
            //     const fd = new FormData();
            //     fd.append('profile_image', this.uploadedPhoto, this.uploadedPhoto.name);
            //     const headers = {
            //         'Authorization': "Bearer " + localStorage.getItem('token'),
            //         'source': localStorage.getItem('source'),
            //         'Content-Type': 'application/json'
            //     };
            //     axios.post(`${url}api/v2/college-profile/upload-logo`, fd, {
            //         headers: headers,
            //         // onUploadProgress: uploadEvent => {
            //         //     console.log('Upload Progress: ' + Math.round(uploadEvent.loaded/uploadEvent.total * 100) + "%")
            //         // }
            //     })
            //         .then(res => {
            //             this.loaderHide();
            //             if (res.status == 200) {
            //                 var image = res['data']['response']['logo'];
            //                 t.$store.dispatch("setImage", image);
            //                 toastr.success('Picture Uploaded Successfully', 'Success');
            //             } else {
            //                 toastr.error('Some error occurred. Try again later', 'Oops!!');
            //             }
            //         })
            //
            // },
            streamModal(w){
                if(w){
                  $('#streamModal').css({"display": "block"});
                }
            },

            courseModal(w, e = null) {
                if (w) {
                    $('#courseModal').css({"display": "block"});
                    this.$refs.cModal.anotherModal();
                } else {
                    var el = e.currentTarget;
                    var data_key = el.getAttribute('data-key');
                    this.$refs.cModal.anotherModal(data_key);
                }
            },
            update() {
                var t = this;
                var url = t.$store.getters.getDomain;
                t.website_error = '';
                t.city_error = '';
                t.affiliated_to_error = '';

                var flag = 0;
                if (t.college_city == '') {
                    t.city_error = "This field can't be empty";
                    flag = 1;
                }
                if (t.college_website == '') {
                    t.website_error = "This field can't be empty";
                    flag = 1;
                }
                if (t.college_affiliated_to == '') {
                    t.affiliated_to_error = "This field can't be empty";
                    flag = 1;
                }

                if (flag === 1) {
                    return false;
                }

                var data = {
                    'description': t.college_description,
                    'location': t.college_city,
                    'university': t.college_affiliated_to,
                    'website': t.college_website,
                    'org_enc_id': t.college_enc_id,
                };
                showLoader();
                //request to update basic info
                axios.post(`${url}api/v2/college-profile/save-detail`, data, {headers: requestHeaders()}).then(function (response) {
                    hideLoader();
                });

            },
            changePassword() {
                var t = this;
                var url = t.$store.getters.getDomain;

                if(!t.validateForm()){
                    return false;
                }
                var elements = document.getElementById('changePassForm').elements;
                var obj = {};
                for (var i = 0; i < elements.length; i++) {
                    var item = elements.item(i);
                    if (item.name != "") {
                        obj[item.name] = item.value;
                    }
                }
                showLoader();
                //request to update basic info
                axios.post(`${url}api/v2/auth/change-password`, obj, {headers: requestHeaders()}).then(function (response) {
                    hideLoader();
                    if (response['data']['response']['status'] == 200) {
                        toastr.success('Password changed successfully', 'Success');
                        for (var i = 0; i < elements.length; i++) {
                            var item = elements.item(i);
                                item.value = "";
                        }
                    } else if (response['data']['response']['status'] == 403) {
                        toastr.error('The old password did not match. Please Try again', 'Oops!!');
                    } else if (response['data']['response']['status'] == 409) {
                        toastr.error(response['data']['response'][0].new_password[0], 'Oops!!');
                    } else {
                        toastr.error('Some error occurred. Try again later', 'Oops!!');
                    }
                });
            },
            removeStream(event){
                var result = confirm("Are You Sure Want to Remove!");
                if(result == true){
                  var t = this;
                  showLoader();
                  var element = event.currentTarget;
                  var data_key = element.getAttribute('data-key');
                  var url = t.$store.getters.getDomain;

                  axios.post(`${url}api/v2/college-profile/remove-stream`, {course_enc_id:data_key}, {headers: requestHeaders()})
                  .then(function (response){
                      if(response['data']['response']['status'] == 200){
                        toastr.success('Stream Successfully Removed', 'Removed');
                        t.streams = response['data']['response']['streams'];
                      }else {
                        toastr.error('Some error occurred. Try again later', 'Oops!!');
                      }
                      hideLoader();
                  })
                }
            },
            removeCourse(event){
                var result = confirm("Are You Sure Want to Remove!");
                if (result == true) {
                  var t = this;
                  showLoader();
                  var element = event.currentTarget;
                  var data_key = element.getAttribute('data-key');
                  var url = t.$store.getters.getDomain;

                  axios.post(`${url}api/v2/college-profile/remove-course`, {course_enc_id:data_key}, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                      toastr.success('Course Successfully Removed', 'Removed');
                      t.coursesList = response['data']['response']['courses'];
                      t.$store.dispatch("setCourses", t.coursesList);
                    } else {
                      toastr.error('Some error occurred. Try again later', 'Oops!!');
                    }
                    hideLoader();
                  });
                }
            },
            validateForm: function () {
                var x, y, z, i, valid = true, a = this;
                x = document.getElementById("changePassForm");
                y = x.getElementsByTagName("input");
                for (i = 0; i < y.length; i++) {
                    if (y[i].value == "") {
                        y[i].className += " invalid";
                        valid = false;
                    } else {
                        y[i].classList.remove('invalid');
                    }
                }
                if (document.getElementById('new-password').value != document.getElementById('confirm-password').value) {
                    document.getElementById('new-password').className += " invalid";
                    document.getElementById('confirm-password').className += " invalid";
                    valid = false;
                }

                if (document.getElementById('new-password').value.length < 8) {
                    alert('Password must have 8 characters. Use small letters with combination of Capitals and numbers with special symbols like @*.')
                    document.getElementById('new-password').className += " invalid";
                    valid = false;
                }
                return valid;
            },
            htmlDecoder(str) {
                var textArea = document.createElement('textarea');
                textArea.innerHTML = str;
                return textArea.value;
            }
        }
    }
</script>

<style scoped>
    .all-courses{
      padding: 20px 0 0 0;
    }
    .mt30{
        margin-top: 30px;
    }
    .align-center {
        text-align: center;
    }

    .add-course {
        background: #00a0e3;
        padding: 10px 15px;
        color: #fff;
        border-radius: 10px 0px 10px 0;
        font-size: 13px;
        border: none;
        margin-top: 15px;
    }

    .add-course:hover {
        text-decoration: none;
        border-radius: 0px;
        transition: .5s all;
    }
</style>